import { z } from 'zod';

export const ClientAppDetailsSchema = z.object({
  appId: z.string(),
  oauthId: z.string(),
  domains: z.array(z.string()),
  displayName: z.string(),
  isActive: z.boolean(),
  isSecureInitRequired: z.boolean(),
  maxSendLimitUsd: z.string(),
  isThirdParty: z.boolean().optional(),
  /**
   * True while the app is still in the trial tier, i.e. it has NOT been through manual review.
   * `undefined` when the trial signal is unavailable (hardcoded app fallback, local production
   * mock, or an onramp-service response that predates the flag), so security checks must treat
   * anything other than an explicit `false` as trial (fail closed).
   */
  isTrialMode: z.boolean().optional(),
  maxGuestCheckoutLimitUsd: z.string(),
  /** Only populated for apps in the pre-prod (non-approved) app tier: trial, demo etc. */
  maxTransactionCount: z.string(),
  /** Only populated for apps in the pre-prod (non-approved) app tier: trial, demo etc. */
  maxAmountPerTransaction: z.string(),
  /** Only populated for apps in the pre-prod (non-approved) app tier: trial, demo etc. */
  currentTransactionCount: z.string(),
});

export type ClientAppDetails = z.infer<typeof ClientAppDetailsSchema>;
